var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all_box"},[_c('div',{staticClass:"cover_container"},[_c('img',{staticClass:"commitment_box",attrs:{"crossorigin":"anonymous","src":_vm.commitmentObj.commitmentUrl,"alt":""}}),_c('div',{staticClass:"flexbox sign_box"},[_vm._v(" 用户签名:"),_c('img',{attrs:{"src":_vm.commitmentObj.signUrl,"alt":"","crossorigin":"anonymous"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }